import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { IdCard } from "lucide-react";

// Subtle top-nav pill nudging clients to finish their Driver Profile.
// Renders nothing while loading or once the profile is 100% complete.
export default function DriverProfileNudge({ className = "" }) {
  const [pct, setPct] = useState(null);

  useEffect(() => {
    api.get("/driver-profile").then(({ data }) => setPct(data.completion_pct)).catch(() => {});
  }, []);

  if (pct === null || pct >= 100) return null;

  return (
    <Link to="/profile" data-testid="driver-profile-nudge"
      className={`group flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 pl-1.5 pr-3 py-1 text-xs font-semibold text-amber-700 hover:bg-amber-100 transition-colors ${className}`}
      title="Finish your Driver Profile for instant auto-fill">
      <span className="relative inline-flex h-6 w-6 items-center justify-center">
        <svg className="h-6 w-6 -rotate-90" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" fill="none" stroke="#fde68a" strokeWidth="3" />
          <circle cx="12" cy="12" r="9" fill="none" stroke="#d97706" strokeWidth="3" strokeLinecap="round"
            strokeDasharray={2 * Math.PI * 9} strokeDashoffset={2 * Math.PI * 9 * (1 - pct / 100)} />
        </svg>
        <IdCard className="absolute w-3 h-3 text-amber-700" />
      </span>
      Profile {pct}%
    </Link>
  );
}
